/**
 * NODE-NESTJS-V, 4 November 2026: "select all" in the invite modal fired one
 * POST /events/:id/invite/:userId per member, all at once, and a big list hit
 * the API's limit of 300 calls per 10 seconds on that route. The invitations
 * now leave in waves of 10, each wave waiting 400 ms after the previous one
 * has answered: at most 250 calls per 10 seconds, whatever the list.
 */
export const INVITATION_WAVE_SIZE = 10;
export const INVITATION_WAVE_PAUSE_MS = 400;

/** Same answer as Promise.allSettled over every item, in the same order. */
export async function settleInSmallWaves<T, R>(
  items: readonly T[],
  send: (item: T) => Promise<R>,
): Promise<PromiseSettledResult<R>[]> {
  const results: PromiseSettledResult<R>[] = [];

  for (let start = 0; start < items.length; start += INVITATION_WAVE_SIZE) {
    if (start > 0) {
      await new Promise((resolve) => setTimeout(resolve, INVITATION_WAVE_PAUSE_MS));
    }
    results.push(...(await Promise.allSettled(items.slice(start, start + INVITATION_WAVE_SIZE).map(send))));
  }

  return results;
}
